<template>
    <v-container fluid grid-list-xl class="c-container">
        <h5 class="headline c-mb-4">Notrufe</h5>

        <h5 class="headline c-mb-4">Fridas CARU</h5>
        <div class="subheading c-mb-1">Gerätestatus</div>
        <h5 v-if="currentDevice.hasConnection" class="headline c-mb-4 primary--text">online</h5>
        <h5 v-else class="headline c-mb-4 error--text">offline</h5>


        <div class="subheading c-mb-2">Notrufe</div>

        <div class="c-hcard c-mb-3 elevation-11">
            <div class="c-hcard--title">
                <h3 class="display-3 c-mb-1">{{currentDevice.alarms12h.length}}</h3>
                <label>Notrufe in den letzten 12 Stunden</label>
            </div>
            <div class="c-hcard--content">
                <ul>
                    <transition-group name="list">
                        <li v-for="alarm in currentDevice.alarms12h.slice(0, 3)" v-bind:key="alarm.ts">
                            <div class="c-hcard--content__title subheading">{{alarm.ts | niceDate}}</div>
                            <div class="c-hcard--meta hidden-sm-and-down">Anruf wurde angenommen</div>
                        </li>
                    </transition-group>
                    <li v-if="currentDevice.alarms12h.length > 3">
                        <div class="c-hcard--content__title">{{currentDevice.alarms12h.length - 3}} weitere</div>
                    </li>
                </ul>
            </div>
        </div>
    </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const {mapState} = createNamespacedHelpers('device')

export default {
  name: 'RemoteCare',
  data () {
    return {
      editMode: false,
      valid: false,
      recipient: {
        name: 'Frida Hess',
        deviceId: 'p8pnh7j6',
        location: 'Frauenfeld Altersheim 3rd floor, 304',
        responsible: 'Kristina',
        contactPhone: '(123) 444-4444'
      }
    }
  },
  computed: {
    ...mapState({
      currentDevice: state => state.currentDevice,
    })
  },
  created () {},
  methods: {}
}
</script>

<style lang="scss">
    @import "../../styles/vars";

    .list-item {
        display: inline-block;
    }

    .list-enter-active {
        transition: all 1.7s;
    }

    .list-enter {
        opacity: 0;
        background-color: $accent-color;
    }
</style>
